function waitForElement(selector, callback, timeout = 5000) {
  const interval = 100;
  let elapsed = 0;
  const check = setInterval(() => {
    const el = document.querySelector(selector);
    if (el) {
      clearInterval(check);
      callback(el);
    } else if (elapsed >= timeout) {
      clearInterval(check);
    }
    elapsed += interval;
  }, interval);
}

// For first section Ebook ConflictingFoods
waitForElement("#shopify-section-template--21296631316515__custom_liquid_VcnNcQ", function (el) {
  el.addEventListener("click", function () {
    var _klOnsite = window._klOnsite || [];
    _klOnsite.openForm("ShbpuD", () => console.log("you triggered the form!"));
  });
});

// For second section Ebook 5Aroma
waitForElement("#shopify-section-template--21296631119907__custom_liquid_AyJjrY", function (el) {
  el.addEventListener("click", function () {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(["openForm", "T4HvM9"]);
  });
});

// For third section Ebook 5gems
waitForElement("#shopify-section-template--21294806728739__custom_liquid_YMDckY", function (el) {
  el.addEventListener("click", function () {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(["openForm", "THZBZ2"]);
  });
});

// For forth section Ebook 23herbs
waitForElement("#shopify-section-template--21296631021603__custom_liquid_QieJ7G", function (el) {
  el.addEventListener("click", function () {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(["openForm", "WWzGAc"]);
  });
});

// For fifth section Ebook Probitic
waitForElement("#shopify-section-template--21294817607716__custom_liquid_QieJ7G", function (el) {
  el.addEventListener("click", function () {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(["openForm", "USbDkP"]);
  });
});